/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ListRoleGrant, ListRoleGrant$inboundSchema } from "./listrolegrant.js";

export type ListUserGrantsResult = {
  /**
   * The user's effective grants in this organization.
   */
  grants: Array<ListRoleGrant>;
};

/** @internal */
export const ListUserGrantsResult$inboundSchema: z.ZodMiniType<
  ListUserGrantsResult,
  unknown
> = z.object({
  grants: z.array(ListRoleGrant$inboundSchema),
});

export function listUserGrantsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListUserGrantsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUserGrantsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserGrantsResult' from JSON`,
  );
}
